import { DeclarationsFormValues } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationChecksComplete/JoinAndAllocationDeclarations/useJoinAndAllocationDeclarationsController';
import { useState } from 'react';
import { OtherDetailsFormValues } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationPersonalDetails/JoinAndAllocationOtherDetails/useJoinAndAllocationOtherDetails.types';
import { PIVInfoForm } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationPersonalDetails/JoinAndAllocationPIVInformation/useJoinAndAllocationPIVInformationController.types';

export enum INVESTOR_BACKUP_PROPERTY {
	pivInformation = 'pivInformation',
	otherDetails = 'otherDetails',
	declarations = 'declarations',
}

export interface InvestorFlowBackupData {
	[INVESTOR_BACKUP_PROPERTY.pivInformation]?: Partial<PIVInfoForm>;
	[INVESTOR_BACKUP_PROPERTY.otherDetails]?: OtherDetailsFormValues;
	[INVESTOR_BACKUP_PROPERTY.declarations]?: DeclarationsFormValues;
}

export const useBackupController = () => {
	const [dataBackup, setDataBackup] = useState<InvestorFlowBackupData>({});

	const updateBackupData = (
		key: keyof InvestorFlowBackupData,
		data: InvestorFlowBackupData[keyof InvestorFlowBackupData]
	) => {
		setDataBackup((prevState) => ({
			...prevState,
			[key]: Object.assign({}, prevState[key], data),
		}));
	};

	const removeBackupData = (key: keyof InvestorFlowBackupData) => {
		setDataBackup((prevState) => ({
			...prevState,
			[key]: undefined,
		}));
	};

	return { dataBackup, updateBackupData, removeBackupData };
};
